
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Globe, ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="fixed top-4 right-4 z-50">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="flex items-center gap-2 bg-white dark:bg-gray-800">
            <Globe size={16} />
            <span className="hidden sm:inline">{i18n.language === 'tr' ? 'Türkçe' : 'English'}</span>
            <ChevronDown size={16} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-40 bg-white dark:bg-gray-800">
          <DropdownMenuItem
            onClick={() => changeLanguage('tr')}
            className={`flex items-center gap-2 ${i18n.language === 'tr' ? 'bg-primary/10' : ''}`}
          >
            <span className="text-lg mr-2">🇹🇷</span>
            {t('language.tr')}
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => changeLanguage('en')}
            className={`flex items-center gap-2 ${i18n.language === 'en' ? 'bg-primary/10' : ''}`}
          >
            <span className="text-lg mr-2">🇬🇧</span>
            {t('language.en')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default LanguageSwitcher;
